import { defineStore } from "pinia";
import mushroom from "cem-probe-api";
import { abortAPI } from "@/stores/abortAPI";
import { getSystemType } from "@/utils/systemType";

const abortController = new AbortController();
const storeAbortAPI = abortAPI();

export const ListService = defineStore({
  id: "listService",
  state: () => ({
    data: [],
  }),
  actions: {
    async getAllListService() {
      try {
        storeAbortAPI.setAbort(abortController);
        const response = await mushroom.service.getAllAsync(
          {
            filters: ["type=" + getSystemType()],
          },
          { enabledCache: false },
          {
            abortController: abortController,
          },
          {
            preferRole: "User|NoneWebGUI",
          },
        );
        if (response.result) {
          this.data = response.result;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
  },
  getters: {
    showListService: (state) => {
      return state.data;
    },
  },
});
